const ZEILEN = ['clip', 'medium', 'spur'];
export function ordneMenue(items) {
    const schnell = items.filter((i) => i.gruppe === 'schnell');
    const mehr = items.filter((i) => i.gruppe === 'mehr');
    const zeilen = ZEILEN.map((g) => items.filter((i) => (i.gruppe ?? 'clip') === g)).filter((g) => g.length > 0);
    return { schnell, zeilen, mehr };
}
//# sourceMappingURL=menue.js.map